import React, { useState, useEffect } from 'react';
import get from 'lodash/get';
import Text from 'components/base/Text';
import {
  Flex,
  TooltipStyled,
  LegendSymbol
} from 'components/base/layout-components';
import { SPACES } from 'common/constants/sizes';
import {
  DeliveryProgrssChart,
  emptyData,
  setDeliveryData,
  DeliveryProgrssKanbanChart,
  emptyDataKanban
} from './deliveryProgress.service';
import useIssues from '../../hooks/useIssues';
import { ITERATIONS_TYPES } from 'state/selectors/iterations-picker';

export const DeliveryProgressTooltip = ({ active, payload }) => {
  if (active && payload) {
    const {
      payload: { color, percent },
      value,
      name
    } = payload[0];
    const percentDisplay = percent ? `${percent}% -` : 0;

    return (
      payload && (
        <TooltipStyled padding='0.5rem'>
          <Flex items='center'>
            <LegendSymbol backgroundColor={color} />
            <Text
              pl={SPACES['x-small']}
              size='medium'
              color='shuttleGray'
              whiteSpace='nowrap'
            >
              {percentDisplay} {name}
            </Text>
            <Text
              pl={SPACES['x-small']}
              size='small'
              color='shuttleGray'
              whiteSpace='nowrap'
            >
              ({value} issues)
            </Text>
          </Flex>
        </TooltipStyled>
      )
    );
  }

  return null;
};

const DeliveryProgress = ({
  issuesProps,
  currentIteration,
  isTeamPMConfigurationEnabled
}) => {
  const [deliveryProgressData, setDeliveryProgressData] = useState([]);
  const [donePercent, setDonePercent] = useState(0);

  const { issues, isError } = useIssues({
    issuesProps,
    isTeamPMConfigurationEnabled
  });

  const iterationType = get(currentIteration, 'type', 'scrum');

  useEffect(() => {
    if (!issues || !issues.length) {
      setDeliveryProgressData([]);
      return;
    }

    setDeliveryData(
      issues,
      setDonePercent,
      setDeliveryProgressData,
      iterationType
    );
  }, [issues]);

  if (iterationType !== ITERATIONS_TYPES.SCRUM) {
    return (
      <>
        {!!deliveryProgressData.length && (
          <DeliveryProgrssKanbanChart
            deliveryProgressData={deliveryProgressData}
          />
        )}
        {!deliveryProgressData.length && (
          <DeliveryProgrssKanbanChart
            deliveryProgressData={emptyDataKanban}
            showLegend={false}
            emptyData={true}
          />
        )}
      </>
    );
  }

  return (
    <>
      {!!deliveryProgressData.length && !isError && (
        <DeliveryProgrssChart
          deliveryProgressData={deliveryProgressData}
          donePercent={donePercent}
          showTooltip={true}
          showPercent={true}
          content='Issues Done'
        />
      )}
      {!deliveryProgressData.length && !isError && (
        <DeliveryProgrssChart
          deliveryProgressData={emptyData}
          donePercent='0'
          showTooltip={false}
          showPercent={true}
          content='Issues Done'
        />
      )}
      {isError && (
        <DeliveryProgrssChart
          deliveryProgressData={emptyData}
          showTooltip={false}
          showPercent={false}
          content='Error - missing delivery data'
        />
      )}
    </>
  );
};

export default DeliveryProgress;
